















import { BugTrackerModule } from '@/store/modules/bugtracker/bugtracker.store';
import { BugTrackerIssueViewObject } from '@/types/apiServerContract';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BugTrackerCreateSuccess extends Vue {
    @Prop({ type: Object })
    issue!: BugTrackerIssueViewObject;

    destroyed() {
        BugTrackerModule.clearNewIssue();
    }
}
